import React, { useContext, useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { capitalizeFirstLetter } from "../../utils/Helper";

function RmFilter({ appliedFilters,show, onHide, onApplyFilter,onClear }) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
    const [filters, setFilters] = useState({
        first_name: appliedFilters?.first_name || "",
        last_name: appliedFilters?.last_name || "",
        email: appliedFilters?.email || "",
        channel_partner_id: appliedFilters?.channel_partner_id || "",
        type_id:appliedFilters?.type_id || "",
        region_id: appliedFilters?.region_id || "",
        state_id:appliedFilters?.state_id || "",
        city_id: appliedFilters?.city_id || "",
        status: appliedFilters?.status || "",
      });

  const [filterOptions, setFilterOptions] = useState({
    countries: [],
    regions: [],
    rmTypes: [],
    channelPtNames:[]
  });
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const navigate = useNavigate();

  useEffect(() => {
    fetchFilterOptions();
    if (appliedFilters?.region_id)fetchStates(appliedFilters?.region_id);
    if (appliedFilters?.state_id) fetchCities(appliedFilters?.state_id);
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const [regions, rmType,channelPtNames] = await Promise.all([
        APIServices.get(`/admin/cms/region_list/${"101"}`, headers),
        APIServices.get("/admin/relationship_manager/type_list", headers),
        APIServices.get("/admin/channel_partner/short_list", headers),
      ]);

  
      setFilterOptions({
        regions: regions?.data?.list || [],
        rmTypes: rmType?.data?.list || [],
        channelPtNames: channelPtNames?.data?.list || [],
      });
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };


  const fetchStates = async (regionId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
      );
      if (response?.status === 200) {
        const stateList = response?.data?.list || [];
        setStates(stateList)
        // setFilterOptions((pre)=>({...pre, states:  stateList}));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setStates([])
        // setFilterOptions((pre)=>({...pre, states:  []}));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
      );
      if (response?.status === 200) {
        const citiesList = response?.data?.list || [];
        setCities(citiesList)
        // setFilterOptions((pre)=>({...pre, cities:  citiesList}));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setCities([])
        // setFilterOptions((pre)=>({...pre, cities:  []}));
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });

    if (name === "region_id") {
        setFilters((pre)=>({ ...pre, state_id : "",city_id  : "" }));
        fetchStates(value);
      }
      if (name === "state_id") {
        setFilters((pre)=>({ ...pre,city_id  : "" }));
        fetchCities(value);
      }
  };

  return (
    <Offcanvas
      className=""
      show={show}
      onHide={onHide}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter By
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 mom_filter">
        <Form className="filter_form">
          <div>
            <label className="font_blue_14 font-500 mb-2">
            First Name
            </label>
            <Form.Control
                type="text"
                placeholder="Enter First Name"
                name="first_name"
                value={filters.first_name}
                onChange={handleFilterChange} 
            />
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">
            Last Name
            </label>
            <Form.Control
                type="text"
                placeholder="Enter Last Name"
                name="last_name"
                value={filters.last_name}
                onChange={handleFilterChange} 
            />
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">
              Channel Partner Email
            </label>
            <Form.Control
              name="email"
              placeholder="Enter Email"
              value={filters.email}
              onChange={handleFilterChange}
            >
            </Form.Control>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">
              Channel Partner Type
            </label>
            <Form.Select
              name="type_id"
              value={filters.type_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Channel Partner Type</option>
              {filterOptions?.rmTypes?.map((chPtType) => (
                <option key={chPtType.id} value={chPtType.id}>
                  {chPtType.name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">
              Channel Partner Name
            </label>
            <Form.Select
              name="channel_partner_id"
              value={filters.channel_partner_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Channel Partner Name</option>
              {filterOptions?.channelPtNames?.map((chPtType) => (
                <option key={chPtType.id} value={chPtType.id}>
                  {capitalizeFirstLetter(chPtType.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">Select status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </div>      
          <div>
            <label className="font_blue_14 font-500 mb-2">Region</label>
            <Form.Select
              name="region_id"
              value={filters.region_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Region</option>
              {filterOptions?.regions?.map((region) => (
                <option key={region.id} value={region.id}>
                  {capitalizeFirstLetter(region.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">State</label>
            <Form.Select
              name="state_id"
              value={filters.state_id}
              onChange={handleFilterChange}
            >
              <option value="">Select State</option>
              {states?.map((state) => (
                <option key={state.id} value={state.id}>
                  {capitalizeFirstLetter(state.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">City</label>
            <Form.Select
              name="city_id"
              value={filters.city_id}
              onChange={handleFilterChange}
            >
              <option value="">Select City</option>
              {cities?.map((city) => (
                <option key={city.id} value={city.id}>
                  {capitalizeFirstLetter(city.name) }
                </option>
              ))}
            </Form.Select>
          </div>
        </Form>
        <div className="offcanvas-footer">
          <button className="btn blue_border" onClick={onClear}>
            Clear
          </button>
          <button
            className="btn red_button"
            onClick={() => onApplyFilter(filters)}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default RmFilter;
